import TrialUpgradeLink from '../../../trialUser/TrialUpgradeLink';
import { nameableSelectionNames } from '../utils/nameable-selection-names';

export const TRIAL_COMPANY_RESTRICTION_TITLE =
  'Company not available on your trial';

const MAX_NAMES_SHOWN = 3;

/**
 * Renders the blocked companies, or `undefined` when none are nameable — see
 * `nameableSelectionNames` for why id-only names are dropped.
 */
const summarizeBlocked = (blockedNames: string[]): string | undefined => {
  const nameable = nameableSelectionNames(blockedNames);
  if (nameable.length === 0) {
    return undefined;
  }
  if (nameable.length <= MAX_NAMES_SHOWN) {
    return nameable.join(', ');
  }
  const shown = nameable.slice(0, MAX_NAMES_SHOWN).join(', ');
  return `${shown} and ${nameable.length - MAX_NAMES_SHOWN} more`;
};

/**
 * The single wording for "your plan doesn't include that company", shared by
 * the toast (search box / page apply) and the assistant's inline chart error.
 * Both routes are the same refusal, so a user who hits it twice reads the same
 * sentence and gets the same upgrade affordance either way.
 *
 * `toastIdClose` is only meaningful in the toast — the link closes its own
 * toast on success.
 */
export const TrialCompanyRestrictionMessage = ({
  blockedNames,
  toastIdClose,
}: {
  blockedNames: string[];
  toastIdClose?: string;
}) => {
  const summary = summarizeBlocked(blockedNames);
  const subject =
    summary === undefined
      ? 'Some companies are'
      : `${summary} ${summary.includes(',') ? 'are' : 'is'}`;

  return (
    <span>
      {`${subject} not included in your trial, so we kept your available companies. To analyze them, `}
      <TrialUpgradeLink toastIdClose={toastIdClose} />.
    </span>
  );
};
